export default "__VITE_ASSET__qVc$sL68__"